import axios from 'axios'
import { REACT_APP_API } from '../../config'

export async function createOrUpdateBonificationByVersion(body) {
    const response = await axios.put(
        `${REACT_APP_API}/bonifications/conventional/version`,
        body
    )
    return response?.data?.data
}
